import dayjs from "dayjs";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";

import { getLastEstimatedItemAndSlot, renderLatenessWarning } from "../../context/QueueContext";
import { Expert } from "../../models/expert";
import { ConsultationType } from "../../models/global";

import ExpertBusyDuration from "./ExpertBusyDuration";

interface Props {
  expert: Expert;
  channel: ConsultationType;
  className?: string;
}

const ExpertQueueSummary: React.FC<Props> = ({ expert, channel, className }) => {
  const { t } = useTranslation("consultations");
  const filteredExpertQueue = expert?.queue?.items?.filter((i) => i.type !== "BREAK" && !i.metadata?.isEphemeral) || [];
  const lastEstimatedItemAndSlot = getLastEstimatedItemAndSlot(expert);
  const waitTime = lastEstimatedItemAndSlot.item.startAt.diff(dayjs(), "minute");

  const minutesToTime = (minutes) => {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (h > 0) return t("common:localHM", { hours: h, minutes: String(m).padStart(2, "0") });
    return t("common:localM", { minutes: m });
  };

  return expert?.queue ? (
    <>
      {filteredExpertQueue.length === 0
        ? (
          <>
            {(channel !== "PHONE" || (expert.presenceStatus.phoneStatus && !expert.presenceStatus.activityStatus)) && (
              <div className={`flex flex-col text-sm p-6 bg-slate-100 rounded-sm gap-3 ${className}`}>
                <div className="text-lg font-semibold py-2 text-center">
                  {t(
                    expert.presenceStatus.activityStatus && expert.queue?.items?.length === 0
                      ? "queue.immediate.title"
                      : "queue.empty.title",
                  )}
                </div>
                <div className="flex flex-col gap-4 text-center">
                  <div>
                    {
                      t(
                        expert.presenceStatus.activityStatus && expert.queue?.items?.length === 0
                          ? `queue.immediate.explaination.${channel.toLowerCase()}`
                          : `queue.empty.explaination.${channel.toLowerCase()}`,
                      )
                    }
                  </div>
                  {waitTime > 0 && (
                    <>
                      {/* <div>
                        <Trans
                          i18nKey="queue.waitTime"
                          ns="consultations"
                          values={{ waitTime: minutesToTime(waitTime) }}
                          components={[<span className="font-semibold"> </span>]}
                        />
                      </div> */}
                      <div>
                        <Trans
                          i18nKey="queue.startTime"
                          ns="consultations"
                          values={{ startTime: lastEstimatedItemAndSlot.item.startAt.format("LT") }}
                          components={[<span className="font-semibold"> </span>]}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </>
        ) : (
          <div className="space-y-2">
            {renderLatenessWarning(lastEstimatedItemAndSlot.item.lateness, t)}
            <div className={`flex flex-col text-sm p-6 bg-slate-100 rounded-sm gap-3 ${className}`}>
              <div>
                <Trans
                  i18nKey={filteredExpertQueue.length === 1 ? "queue.length.single" : "queue.length.multiple"}
                  ns="consultations"
                  values={{ queueLength: filteredExpertQueue.length }}
                  components={[<span className="font-semibold"> </span>]}
                />
              </div>
              <ExpertBusyDuration expert={expert} />
              {waitTime
                ? (
                  <>
                    {/* <div>
                    <Trans
                      i18nKey="queue.waitTime"
                      ns="consultations"
                      values={{ waitTime: minutesToTime(waitTime) }}
                      components={[<span className="font-semibold"> </span>]}
                    />
                  </div> */}
                    <div>
                      <Trans
                        i18nKey="queue.startTime"
                        ns="consultations"
                        values={{ startTime: lastEstimatedItemAndSlot.item.startAt.format("LT") }}
                        components={[<span className="font-semibold"> </span>]}
                      />
                    </div>
                  </>
                )
                : (
                  <div>
                    <Trans
                      i18nKey="queue.startAsap"
                      ns="consultations"
                      components={[<span className="font-semibold"> </span>]}
                    />
                  </div>
                )}
              {lastEstimatedItemAndSlot.slot
                && <span className="font-semibold">{t("queue.end", { at: lastEstimatedItemAndSlot.slot.end.format("LT") })}</span>}
            </div>

          </div>
        )}
    </>
  )
    : (<></>);
};

export default ExpertQueueSummary;
